// extracted by mini-css-extract-plugin
export default {"safety":"safety___HmXbQ66","name":"name___HmXbQ66"};